import { Link } from "react-router-dom";
import { Clock, Layers, MonitorSmartphone } from "lucide-react";
import { inr } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function CourseCard({ course }) {
  const discounted = course.discount > 0 ? Math.round(course.fees * (1 - course.discount / 100)) : course.fees;
  return (
    <Link
      to={`/course/${course.slug}`}
      className="group bg-card border border-white/10 rounded-xl overflow-hidden hover:border-orange-500/50 transition-colors flex flex-col"
      data-testid={`course-card-${course.slug}`}
    >
      <div className="relative h-44 overflow-hidden">
        <img src={course.image} alt={course.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-base/90 to-transparent" />
        <div className="absolute bottom-3 left-3 flex flex-wrap gap-1.5">
          {(course.badges || []).slice(0, 2).map((b) => (
            <span key={b} className="text-[10px] font-semibold uppercase tracking-wider bg-navy-deep/80 backdrop-blur border border-orange-500/40 text-orange-300 rounded-full px-2 py-0.5">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-orange-500 mr-1 align-middle" />{b}
            </span>
          ))}
        </div>
        {course.featured && (
          <span className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-wider bg-orange-600 text-white rounded-full px-2.5 py-1">Featured</span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="text-[11px] uppercase tracking-[0.15em] text-orange-400 font-semibold mb-1.5">{course.subcategory || course.category_slug}</div>
        <h3 className="font-display font-semibold text-white text-lg leading-snug mb-2 group-hover:text-orange-300 transition-colors">{course.title}</h3>
        <p className="text-sm text-slate-400 line-clamp-2 mb-4">{course.short_description}</p>
        <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-slate-400 mb-4">
          <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-orange-400" />{course.duration}</span>
          <span className="flex items-center gap-1.5"><Layers className="w-3.5 h-3.5 text-orange-400" />{course.level}</span>
          <span className="flex items-center gap-1.5"><MonitorSmartphone className="w-3.5 h-3.5 text-orange-400" />{course.mode}</span>
        </div>
        <div className="mt-auto flex items-center justify-between pt-3 border-t border-white/10">
          <div>
            {course.discount > 0 && <span className="text-xs text-slate-500 line-through mr-2">{inr(course.fees)}</span>}
            <span className="font-display font-bold text-white">{inr(discounted)}</span>
          </div>
          <span className="text-xs font-semibold text-orange-400 group-hover:translate-x-1 transition-transform">View Details →</span>
        </div>
      </div>
    </Link>
  );
}
